import { render, staticRenderFns } from "./bpAssets.vue?vue&type=template&id=6dd634bf&scoped=true&"
import script from "./bpAssets.vue?vue&type=script&lang=js&"
export * from "./bpAssets.vue?vue&type=script&lang=js&"
import style0 from "./bpAssets.vue?vue&type=style&index=0&id=6dd634bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd634bf",
  null
  
)

export default component.exports